import React, { Fragment } from 'react';

const About = () => {
  return (
    <Fragment>
      <h1>About App</h1>
      <p>Search Github user</p>
      <p>version: 1.0.0</p>
    </Fragment>
  );
};

export default About;
